// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1VvzU","footer":"Form_footer__1JlPn"};